import React, { useEffect, useRef, useState, useContext } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import AuthContext from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { ImEye, ImEyeBlocked } from "react-icons/im";
import Transparent from "../assets/images/transparent.gif";
const Login = () => {
  const navigate = useNavigate();
  let { loginUser, user,loginError } = useContext(AuthContext);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      username: "",
      password: "",
      uniqueId: Math.random() * 10000,
    },
  });
  const [getValidateCode, setValidateCode] = useState("");

  const onSubmit = (data) => {
    if (parseInt(data.validateCode) === parseInt(getValidateCode)) {
      loginUser(data);
      navigate("/");
    }
  };

  const canvasRef = useRef(null);

  const [canvaData, setCanvaData] = useState("Hello wordl");

  const changeCode = () => {
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");
    context.font = "bold 50px sans-serif";
    const code = Math.floor(1000 + Math.random() * 9000);
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.fillText(code, 10, 50);
    setValidateCode(code);
  };

  useEffect(() => {
    // console.log('%cLogin.js line:43 user', 'color: #007acc;', user);
    if (user !== null) {
      // console.log("MMMM")
      // window.location.reload();
      navigate("/");
    }
  }, [user]);

  useEffect(() => {
    changeCode();
  }, []);
  const [passwordType, setPasswordType] = useState("password");
  const togglePassword = (e) => {
    e.preventDefault();
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };
  return (
    <div>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>
      <section className="login-sec">
        <Container fluid>
          <div className="d-flex align-items-center justify-content-center vh-100">
            <div className="main-center">
              <div className="login_box m-auto">
                <div className="login_left">
                  <figure>
                    <img src="assets/images/bg-login.webp" />
                  </figure>
                  {/* <span className="login_logo">
                    <img src="assets/images/logo.png" />
                  </span> */}
                </div>

                <div className="form_outer">
                  <Form onSubmit={handleSubmit(onSubmit)}>
                    <h2 className="text-white">Agent login </h2>
                    <Form.Group className="mb-2">
                      <Form.Control
                        type="text"
                        placeholder="Username"
                        className={errors.username ? "is-invalid" : ""}
                        {...register("username", {
                          required: "Please enter Username",
                        })}
                      />
                      {errors.username && errors.username.message && (
                        <label className="invalid-feedback text-left">
                          {errors.username.message}
                        </label>
                      )}
                    </Form.Group>
                    <Form.Group className="mb-2">
                      <div style={{ position: "relative" }}>
                        <Form.Control
                          type={passwordType ? passwordType : "password"}
                          placeholder="Password"
                          className={errors.password ? "is-invalid" : ""}
                          {...register("password", {
                            required: "Please enter password",
                          })}
                        />
                      </div>
                      {errors.password && errors.password.message && (
                        <label className="invalid-feedback text-left">
                          {errors.password.message}
                        </label>
                      )}
                    </Form.Group>
                    <Form.Group className="position-relative mb-2">
                      <Form.Control
                        type="text"
                        placeholder="Validation Code"
                        maxLength="4"
                        className={errors.validateCode ? "is-invalid" : ""}
                        {...register("validateCode", {
                          required: "validateCode",
                          validate: {
                            validate: (value) =>
                              parseInt(value) === parseInt(getValidateCode) ||
                              "Invalid validate code",
                          },
                        })}
                      />
                      <canvas ref={canvasRef} onClick={changeCode} />

                      {errors.validateCode && errors.validateCode.message && (
                        <label className="invalid-feedback text-left">
                          {errors.validateCode.message}
                        </label>
                      )}
                    </Form.Group>
                    <Button type="submit" className="green-btn theme-btn">
                      Login
                      <span>
                        <img src="assets/images/loginicon.svg" />
                      </span>
                    </Button>
                    {loginError?.status &&
                    <label
                      style={{
                        color: "red",
                        fontSize: "13px",
                        lineHeight: "16px",
                        marginTop: "5px",
                      }}
                      className="text-left"
                    >
                      {loginError?.msg}
                    </label>}

                   
                  </Form>
                </div>
              </div>

              {/* <div id="supportWrap" className="support-wrap">
                <div className="support-service">
                  <a
                    id="support_whatsapp"
                    href="javascript:void(0)"
                    className="support-whatsapp open"
                  >
                    <img src="assets/images/watsapp.svg" title="WhatsApp" />
                  </a>
                  
                </div>

                <div className="support-info">
                  <div
                    id="supportDetail_whatsapp"
                    className="support-detail open"
                  >
                    <a href="javascript:void(0)">#</a>
                  </div>
                </div>
              </div> */}

              <div class="support-wrap extend-support">
                <div class="extend-wrap">
                  <div class="extend-btn" style={{ paddingLeft: "15px" }}>
                    <img
                      src={Transparent}
                      title="customer"
                      class="support-customer"
                    />

                    <a href="#" target="_blank">
                      Customer support1
                    </a>

                    <a
                      href="#"
                      target="_blank"
                      class="split-line"
                    >
                      support2
                    </a>
                  </div>
                  <div class="extend-btn" style={{ paddingLeft: "15px" }}>
                    <img
                      src={Transparent}
                      title="WhatsApp"
                      class="support-whatsapp"
                    />

                    <a href="#" target="_blank">
                      WhatsApp 3
                    </a>

                    <a
                      href="#"
                      target="_blank"
                      class="split-line"
                    >
                      WhatsApp 4
                    </a>
                  </div>
                </div>
                <div class="extend-btn"></div>
                <div class="extend-wrap">
                  <div class="support-social">
                    <img
                      src={Transparent}
                      title="Skype"
                      class="support-skype"
                    />
                    <a href="#" target="_blank">
                      lc247official
                    </a>
                  </div>
                  <div class="support-social">
                    <img src={Transparent} title="Email" class="support-mail" />
                    <a href="#" target="_blank">
                      info@lcx247.live
                    </a>
                  </div>
                  <div class="support-social">
                    <img
                      src={Transparent}
                      title="Instagram"
                      class="support-ig"
                    />

                    <a
                      href="#"
                      target="_blank"
                    >
                      lc247_india
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </div>
  );
};

export default Login;
